import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const sliderRectangleIcon = createIconDefinition(
  'sliderRectangle',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8327 14.1663V5.83301H9.16602V14.1663H10.8327Z" fill="#232426" fill-opacity="0.6"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.666 3.33301C17.5865 3.33301 18.3327 4.0792 18.3327 4.99967V14.9997C18.3327 15.9201 17.5865 16.6663 16.666 16.6663H3.33268C2.41221 16.6663 1.66602 15.9201 1.66602 14.9997V4.99967C1.66602 4.0792 2.41221 3.33301 3.33268 3.33301H16.666ZM3.33268 4.99967H16.666V14.9997H3.33268V4.99967Z" fill="#232426" fill-opacity="0.6"/>
</svg>`,
);
